import type { CoachBoardFocus } from './coach.types'
import styles from './CoachCellReference.module.scss'

type CoachCellReferenceProps = {
  focus: CoachBoardFocus
  label: string
  actionLabel: string
  isPinned: boolean
  onPreview: (focus: CoachBoardFocus) => void
  onPreviewEnd: () => void
  onActivate: (focus: CoachBoardFocus) => void
}

export default function CoachCellReference({
  focus,
  label,
  actionLabel,
  isPinned,
  onPreview,
  onPreviewEnd,
  onActivate,
}: CoachCellReferenceProps) {
  return (
    <button
      type="button"
      className={styles.reference}
      aria-label={actionLabel}
      aria-pressed={isPinned}
      title={actionLabel}
      data-coach-cell-reference={focus.cellNumber}
      onMouseEnter={() => onPreview(focus)}
      onMouseLeave={onPreviewEnd}
      onFocus={() => onPreview(focus)}
      onBlur={onPreviewEnd}
      onClick={() => onActivate(focus)}
    >
      <span aria-hidden="true">⌖</span>
      {label}
    </button>
  )
}
